import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { useBulkCreatePolicyAssignments } from 'modules/timeoff/hooks/useBulkCreatePolicyAssignments'

interface Props {
  loading: boolean
  timeoffPolicyId: number
  timeoffPolicyEmployeeIds: number[]
  onClose: () => void
}

const AddEmployeeAssignment = ({
  loading,
  timeoffPolicyId,
  timeoffPolicyEmployeeIds,
  onClose,
}: Props) => {
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeesEmployeeSelectorInput>({
    type: 'manual',
    ids: [],
  })
  const selectedEmployeeIds: number[] = selectedEmployees.type === 'manual' ? selectedEmployees.ids ?? [] : []


  const { loading: loadingBulkCreate, create: bulkCreate } = useBulkCreatePolicyAssignments({
    onCompleted(data) {
      if (data.timeoffMutations.bulkCreateTimeoffCurrentPolicyAssignment?.errors.length) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('settings.timeoff_policies.add_employees_modal.assign.error'),
          time: 2000,
        })
      } else {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
          time: 2000,
        })
      }
    },
  })

  const addEmployees = async () => {
    await bulkCreate({
      employeeSelection: selectedEmployees,
      timeoffPolicyId,
    })
    onClose()
  }

  return (
    <OneModal
      isOpen
      width="sm"
      onClose={() => {
        if (loadingBulkCreate) return
        onClose()
      }}
    >
      <OneModal.Header
        title={i18n.t('settings.timeoff_policies.add_employees_modal.assign.title')}
        description={i18n.t('settings.timeoff_policies.add_employees_modal.assign.description')}
      />
      <OneModal.Content withPadding>
        {loadingBulkCreate || loading ? (
          <Loading />
        ) : (
          <Box gap="s16" flexDirection="column">
            <EmployeeSelectorV2
              messages={{
                placeholder: i18n.t('settings.timeoff_policies.add_employees_modal.assign.title'),
              }}
              forcedFilters={{
                excludeIds: timeoffPolicyEmployeeIds,
              }}
              filters={['team']}
              onChange={setSelectedEmployees}
              options={{
                hideSearchIcon: true,
                hideLabel: true,
              }}
              multiple
            />
          </Box>
        )}
      </OneModal.Content>
      <OneModal.Footer>
        <Box gap="s8" flexDirection="row" justifyContent="flexEnd" width="full">
          <F0Button
            label={i18n.t('settings.timeoff_policies.add_employees_modal.button')}
            onClick={addEmployees}
            disabled={selectedEmployeeIds.length === 0 || loading || loadingBulkCreate}
            loading={loadingBulkCreate}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}

export default observer(AddEmployeeAssignment)
